import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function PlayOnePagerNotice({
  state,
}: {
  readonly state:
    | { readonly kind: "loading" | "empty"; readonly message: string }
    | {
        readonly kind: "error";
        readonly message: string;
        readonly pending: boolean;
        readonly onRetry: () => void;
      };
}) {
  if (state.kind === "empty")
    return <p {...stylex.props(styles.notice)}>{state.message}</p>;

  return (
    <output {...stylex.props(styles.notice)}>
      {state.message}
      {state.kind === "error" ? (
        <>
          {" "}
          <button
            type="button"
            data-cogent-safe
            {...stylex.props(styles.retry)}
            disabled={state.pending}
            onClick={state.onRetry}
          >
            {state.pending ? "Trying again…" : "Try again"}
          </button>
        </>
      ) : null}
    </output>
  );
}

const styles = stylex.create({
  notice: {
    marginBlock: spacing.space4,
    marginInline: 0,
    fontSize: fontSizes.label,
    color: colors.playMuted,
  },
  retry: {
    padding: 0,
    borderWidth: 0,
    backgroundColor: "transparent",
    color: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline",
    textUnderlineOffset: 2,
    cursor: "pointer",
    opacity: { default: 1, ":disabled": 0.6 },
  },
});
